import { Resume } from '@rio/types'

export const getEmptyResumeObject = (): Resume => {
  return {
    id: 0,
    type: 'resume',
    renderingToken: '',
    name: null,
    avatar: {
      transform: null,
      thumbUrl: null,
      mediumUrl: null,
      originalUrl: null,
      blank: true,
    },
    position: null,
    firstName: null,
    lastName: null,
    phoneNumber: null,
    countryName: null,
    city: null,
    address: null,
    postalCode: null,
    birthPlace: null,
    birthDate: null,
    drivingLicense: null,
    nationality: null,
    email: null,
    profile: '',
    template: 'stockholm',
    sectionsOrder: ['profile', 'workExperiences', 'educations', 'socialProfiles', 'skills'],
    color: null,
    spacing: null,
    version: '',
    secureId: null,
    locale: 'en',
    namePronunciation: '',
    resumeSubmissionDate: null,
    married: null,
    numberOfDependents: null,
    spouseObligation: null,
    commutingTime: null,
    spaceForPersonalRequests: null,
    referencesUponRequest: false,
    hideSkillLevel: false,
    sectionTitles: {},
    showPrefillResumeModal: true,
    motivation: null,
    pr: null,
    qualifications: null,
    technicalSkills: null,
    skillsDescription: null,
    employerName: null,
    jobTitle: null,
    linkedin: null,
    jobPostingHostName: null,
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    workExperiences: [],
    educations: [],
    courses: [],
    internships: [],
    activities: [],
    skills: [],
    languages: [],
    hobbies: [],
    references: [],
    socialProfiles: [],
    customSections: [],
    powerStatement: null,
    accomplishments: null,
    aiTaskId: null,
    aiJobStatus: null,
    resumeScore: 0,
    averageScore: 0,
    jobPostingScore: 0,
    jobPostingId: null,
    originalResumeId: null,
    originalResumeAvgScore: null,
    autoTailored: false,
    draft: false,
    templateSettings: null,
    addressPronunciation: null,
    gender: null,
    data: null,
    intention: null,
    ableForSkillCategories: false,
    skillCategories: [],
  }
}
